import { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { authApi } from '@/api/auth'
import { refreshAccessToken } from '@/api/tokenRefresh'
import { LoadingSpinner } from '@/components/LoadingSpinner'
import { useAuthStore } from '@/store/authStore'

export function AuthGuard() {
  const accessToken = useAuthStore((state) => state.accessToken)
  const user = useAuthStore((state) => state.user)
  const setAuth = useAuthStore((state) => state.setAuth)
  const clearAuth = useAuthStore((state) => state.clearAuth)
  const [isChecking, setIsChecking] = useState(!accessToken || !user)

  useEffect(() => {
    if (!accessToken || !user || user.role) {
      return
    }

    let isMounted = true
    authApi
      .getProfile()
      .then((response) => {
        if (isMounted) {
          setAuth(accessToken, response.data)
        }
      })
      .catch(() => {})

    return () => {
      isMounted = false
    }
  }, [accessToken, setAuth, user])

  useEffect(() => {
    if (accessToken && user) {
      setIsChecking(false)
      return
    }

    let isMounted = true

    refreshAccessToken()
      .catch(() => {
        if (isMounted) {
          clearAuth()
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsChecking(false)
        }
      })

    return () => {
      isMounted = false
    }
  }, [accessToken, clearAuth, user])

  if (isChecking) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <LoadingSpinner />
      </div>
    )
  }

  if (!accessToken || !user) {
    // Landing (not /login): logout and expired sessions should return to the public page.
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
